export default __webpack_public_path__ + "static/media/authentication2.540586e6.png";